import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { Empresa } from '../../../pkw-data/core/empresa.model'
import { ExtratoDeRecebimentosService } from '../../extratos-de-recebimentos/shared/extrato-de-recebimentos.service'
import { ExtratoDeVendasService } from '../../extratos-de-vendas/shared/extrato-de-vendas.service'
import { FiltroExtrato } from '../../shared/filtro-extrato'
import { ChartUltimasVendasOptions } from './shared/chart-ultimas-vendas-options'
import { ChartUltimos10DiasOptions } from './shared/chart-ultimos-10-dias-options'
import { ChartUltimosRecebimentosOptions } from './shared/chart-ultimos-recebimentos-options'

@Component({
    selector: 'col-ultimos-10-dias',
    templateUrl: './ultimos-10-dias.component.html',
    styleUrls: ['./ultimos-10-dias.component.scss']
})
export class Ultimos10DiasComponent implements OnChanges {
    static tipos = {
        vendas: 'vendas',
        recebimentos: 'recebimentos'
    }

    @Input() empresa: Empresa

    tipo: string
    tipos = Ultimos10DiasComponent.tipos
    chartOptions: ChartUltimos10DiasOptions

    static obterFiltro(empresa: Empresa) {
        const agora = new Date()
        const fim = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - 1)
        const inicio = new Date(fim.getFullYear(), fim.getMonth(), fim.getDate() - 9)

        return new FiltroExtrato(inicio, fim, empresa)
    }

    constructor(
        private extratoDeVendasService: ExtratoDeVendasService,
        private extratoDeRecebimentosService: ExtratoDeRecebimentosService
    ) {
        this.tipo = Ultimos10DiasComponent.tipos.vendas
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.empresa) {
            this.atualizarChart()
        }
    }

    setTipo(tipo: string) {
        this.tipo = tipo
        this.atualizarChart()
    }

    atualizarChart() {
        switch (this.tipo) {
            case Ultimos10DiasComponent.tipos.vendas:
                this.obterDadosVendas()
                break
            case Ultimos10DiasComponent.tipos.recebimentos:
                this.obterDadosRecebimentos()
                break
        }
    }

    private obterDadosVendas() {
        this.extratoDeVendasService
            .pesquisar(this.obterFiltro().toFilter())
            .subscribe(extratosDeVendas => {
                this.chartOptions = new ChartUltimasVendasOptions(extratosDeVendas[0])
            })
    }

    private obterDadosRecebimentos() {
        this.extratoDeRecebimentosService
            .pesquisar(this.obterFiltro().toFilter())
            .subscribe(extratosDeVendas => {
                this.chartOptions = new ChartUltimosRecebimentosOptions(
                    extratosDeVendas[0]
                )
            })
    }

    private obterFiltro() {
        return Ultimos10DiasComponent.obterFiltro(this.empresa)
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/ultimos-10-dias/ultimos-10-dias.component.ts